import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import TenantUpdateDialog from "@/v2-backoffice-client/tenant/update/TenantUpdateDialog"

export type TenantUpdateMenuItemProps = Omit<ActionMenuItemProps, "onClick"> & {
  tenant: TenantFragment
}

function TenantUpdateMenuItem(props: TenantUpdateMenuItemProps) {
  const { tenant, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="pencil"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Team"}
      </ActionMenu.Item>

      <TenantUpdateDialog
        tenant={tenant}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default TenantUpdateMenuItem
